import NewApp from './NewApp';

export default NewApp;